<template>
  <preloader-component :is-visible="isLoading"/>
</template>

<script>
import { mapGetters } from 'vuex'
import PreloaderComponent from '@/components/Preloader'

export default {
  components: {
    PreloaderComponent
  },
  computed: {
    ...mapGetters(['isLoading'])
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/PreloaderContainer.vue